export default "__VITE_ASSET__BOG8Ans0__"